import React from 'react';
import { Box, Typography, Button, useTheme, useMediaQuery } from '@mui/material';
import MyImage from '../../images/NEU.png';
import resumeFile from '../../Documents/Anand Pandey Resume.pdf'; 

const AboutSection = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery('(min-width: 600px) and (max-width: 960px)');

  return (
    <Box sx={{ 
      backgroundColor: 'white', 
      color: 'black', 
      padding: isMobile ? 2 : 8
    }}>
      <Box sx={{ 
        display: 'flex', 
        flexDirection: isMobile ? 'column' : 'row', 
        justifyContent: 'space-between', 
        flexWrap: 'wrap',
        gap: isMobile ? 2 : 0,
        alignItems: 'center'
      }}>
        <Box sx={{ 
          flexBasis: isMobile ? '100%' : isTablet ? '100%' : '35%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          maxHeight: isMobile ? 'auto' : '100%',
          marginTop: isMobile ? '0px': '70px'
        }}>
          <img src={MyImage} alt="NEU background" style={{ width: '100%', height: 'auto', borderRadius: '15px', maxHeight: '100%' }} />
        </Box>
        <Box sx={{ 
          flexBasis: isMobile || isTablet ? '100%' : '60%', 
          textAlign: isMobile || isTablet ? 'center' : 'inherit',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: isMobile || isTablet ? 'center' : 'flex-start',
          paddingTop: isMobile ? '20px' : '0'
        }}>
          <Typography component="h1" sx={{ 
            fontSize: isMobile ? '40px' : '60px', 
            fontWeight: '600',
            color: '#101010',
            marginBottom: isMobile ? '20px' : '10px'
          }}>
            <span style={{ color: '#f9004d' }}>ABOUT</span> ME
          </Typography>
          <Typography paragraph sx={{ 
            fontSize: isMobile ? '16px' : '20px', 
            marginBottom: '15px'
          }}>
            Hi, I'm Anand Somnath Pandey, a dedicated software engineer with a keen interest in building innovative solutions. 
            I hold a bachelor's degree in Information Technology from Mumbai University, which I completed in 2021.<br/><br/>

            Following my graduation, I spent two years at Wipro Ltd. as a Software Engineer, gaining valuable experience and 
            I have strong expertise in React, full-stack development, cloud technologies, and CI/CD pipelines.<br/><br/>

            I am now advancing my knowledge as a master's student in Information Systems at Northeastern University. 
            My coursework and projects have deepened my expertise in software development, particularly in areas like web 
            development, object-oriented programming, and cloud computing.<br/><br/>

            My technical toolkit includes a diverse array of languages, cloud technologies and frameworks such as Java, Python, React, Docker, Jenkis, Kubernetes and Node.js. 
            I'm passionate about creating seamless user experiences and developing applications that solve real-world problems.<br/>

          </Typography>
          <Button 
            component="a"
            href={resumeFile}
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              backgroundColor: '#f9004d',
              borderRadius: '5px',
              color: 'white',
              fontWeight: 'bold',
              fontSize: isMobile ? '12px' : '15px',
              transition: '.5s',
              border: '2px solid transparent',
              '&:hover': {
                backgroundColor: 'transparent',
                color: 'black',
                border: '2px solid #f9004d'
              }
            }}
          >
            Resume
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default AboutSection;
